import { TFunction } from 'i18next';

// Grow rejects a repeat charge that reuses a transaction identifier. Reachable from "buy again",
// which seeds the identifier on the source pass -- the customer's new pass is already waiting.
const GROW_DUPLICATE_TRANSACTION_ERROR = '1010';
// Square answers a reused idempotency key with the original payment, which the API reports under these ids.
const DUPLICATE_PROVIDER_ERROR = 'duplicate';
const NO_SAVED_CARD_PROVIDER_ERROR = 'no_saved_card';

/**
 * Turns a failed saved-card charge into something a customer can act on. The portal has no toast
 * system, so callers render this in an inline Alert.
 */
export const savedCardErrorMessage = (e: any, t: TFunction): string => {
  const detail = e?.status === 400 ? e?.body?.detail : null;
  if (detail === 'pass has no saved card') {
    return t('manage_passes.buyAgain.errorNoCard');
  }
  const providerError = detail?.provider_error ?? detail?.grow_error;
  if (providerError) {
    const errorId = String(providerError.id);
    if (errorId === GROW_DUPLICATE_TRANSACTION_ERROR || errorId === DUPLICATE_PROVIDER_ERROR) {
      return t('manage_passes.buyAgain.errorAlreadyBought');
    }
    if (errorId === NO_SAVED_CARD_PROVIDER_ERROR) {
      return t('manage_passes.buyAgain.errorNoCard');
    }
    return providerError.message || t('manage_passes.buyAgain.errorGeneric');
  }
  return t('manage_passes.buyAgain.errorGeneric');
};
